import type { CollectionLinkDecision } from '@/lib/seo/article-collection-link-gate'

/** Only offer a collection CTA when its server lookup established a destination. */
export function brandCollectionHref(slug: string, hubSlug: string | null, decision: CollectionLinkDecision | null): string | null {
  if (hubSlug) return `/${hubSlug}`
  if (decision?.kind === 'keep') return `/collections/${slug}`
  if (decision?.kind === 'rewrite') return decision.to
  return null
}

/**
 * FRIDGE-1261 — the catalog header's "See all" action. Offered only when the page shows
 * part of the catalog AND a verified destination exists. brandCollectionHref returns null
 * for a brand with no active hub and no linkable collection; before this, the header was
 * handed `{ href: null }` and next/link threw on every render, a production 500 on
 * /brands/eqtemp, /brands/marvel, /brands/monogram and /brands/viking.
 */
export function brandCatalogSeeAllAction(
  productCount: number,
  shownCount: number,
  collectionHref: string | null | undefined,
): { type: 'link'; label: string; href: string } | undefined {
  if (typeof collectionHref !== 'string' || collectionHref === '') return undefined
  if (!(productCount > shownCount)) return undefined
  return { type: 'link', label: 'See all', href: collectionHref }
}
